import {
  ProductGalleryNextControl,
  ProductGalleryVariant,
} from '@vs-shop/commerce-ui/productGallery';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

type Props = { onNext: () => void };

/** The lightbox's step on, named in this tenant's language. */
export default function GalleryModalNextButton({ onNext }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <ProductGalleryNextControl
      variant={ProductGalleryVariant.OVERLAY}
      onClick={() => {
        onNext();
      }}
      aria-label={intl.formatMessage({
        id: 'component.server.page.product.gallery.galleryModalNextButton.next',
        defaultMessage: 'Další',
      })}
    />
  );
}
